export const FETCH_GETTOUCH_REQUEST = 'FETCH_GETTOUCH_REQUEST';
export const FETCH_GETTOUCH_SUCCESS = 'FETCH_GETTOUCH_SUCCESS';
export const FETCH_GETTOUCH_FAILURE = 'FETCH_GETTOUCH_FAILURE';

export const SEARCH_GETINTOUCH_REQUEST = 'SEARCH_GETINTOUCH_REQUEST';
export const SEARCH_GETINTOUCH_SUCCESS = 'SEARCH_GETINTOUCH_SUCCESS';
export const SEARCH_GETINTOUCH_FAILURE = 'SEARCH_GETINTOUCH_FAILURE';

export const fetchTouchRequest = (page, limit) => ({
  type: FETCH_GETTOUCH_REQUEST,
  payload: { page, limit },
});

export const fetchTouchSuccess = (getInTouch) => ({
  type: FETCH_GETTOUCH_SUCCESS,
  payload: getInTouch,
});

export const fetchTouchFailure = (error) => ({
  type: FETCH_GETTOUCH_FAILURE,
  payload: error,
});

export const searchGetInTouchRequest = (searchTerm) => ({
  type: SEARCH_GETINTOUCH_REQUEST,
  payload: { searchTerm },
});

export const searchGetInTouchSuccess = (getInTouch) => ({
  type: SEARCH_GETINTOUCH_SUCCESS,
  payload: getInTouch,
});

export const searchGetInTouchFailure = (error) => ({
  type: SEARCH_GETINTOUCH_FAILURE,
  payload: error,
});